import { Select, TypeSelectOption } from '@thefarmersfront/kitchen';

import { type CustomCellRendererProps } from 'ag-grid-react';
import { useShallow } from 'zustand/react/shallow';

import { useReceiveStore } from '~/store';

import { OPTION_PLT, RECEIVE_MODIFICATION_TYPE, TypeReceiveModificationType } from '~/constants';

import type { TypeReceiveDetailOrderItem, TypeReceiveItemEditableFields } from '~/types/receive.types';

import styles from './ReceiveRequestDetailSelectCell.module.scss';

/**
 * [입고관리 > 입고요청관리] 입고요청상세 모달 > Select 셀 렌더러
 */
const ReceiveRequestDetailSelectCell = (
  { node: { rowIndex }, column }: CustomCellRendererProps<TypeReceiveDetailOrderItem>,
  disabled: boolean
) => {
  const [detailModalOrderGoodsList, setDetailModalOrderGoodsList] = useReceiveStore(
    useShallow((state) => [state.detailModalOrderGoodsList, state.setDetailModalOrderGoodsList])
  );

  if (rowIndex === null || column === undefined) {
    return <div>-</div>;
  }

  const colId = column.getColId() as TypeReceiveItemEditableFields;
  const rowData = detailModalOrderGoodsList[rowIndex];
  const cellData = rowData?.[colId] ?? null;
  const cellValue = OPTION_PLT.find(({ value }) => value === String(cellData)) || OPTION_PLT[0];
  const isModified = rowData?.modifiedFields?.includes(colId) ?? false;

  const handleChange = (_: unknown, option: TypeSelectOption<string>) => {
    setDetailModalOrderGoodsList([
      ...detailModalOrderGoodsList.slice(0, rowIndex),
      {
        ...rowData,
        [colId]: JSON.parse(option.value),
        modificationType: RECEIVE_MODIFICATION_TYPE.MODIFY as TypeReceiveModificationType,
        modifiedFields: [...(rowData.modifiedFields ?? []), colId],
      },
      ...detailModalOrderGoodsList.slice(rowIndex + 1),
    ]);
  };

  return (
    <div className={styles['kitchen-component-cell']}>
      <Select
        className={isModified ? styles['modified'] : ''}
        size="tiny"
        dropdownPortalTarget={document.body}
        shouldCloseOnNotInView
        disabled={disabled}
        options={OPTION_PLT}
        value={cellValue}
        onChange={handleChange}
      />
    </div>
  );
};

export default ReceiveRequestDetailSelectCell;
